export default "__VITE_ASSET__CtdfQJRW__"